import { render } from "./ProgramRecommend.vue?vue&type=template&id=143b5a00"
import script from "./ProgramRecommend.vue?vue&type=script&lang=js"
export * from "./ProgramRecommend.vue?vue&type=script&lang=js"

import "./ProgramRecommend.vue?vue&type=style&index=0&id=143b5a00&lang=css"

import exportComponent from "/Volumes/Evolve/WorkSpace/MinonowaRadio/Ver2/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__